<template>
    <div>
        <status-bar v-if="activeStepId !== 2 || isButtonsShow === true" :percent="statusBarPercent" />
        <message
                v-if="isButtonsShow === false && activeStepId === 1 && !canUpload"
                :text="'Исправьте все ошибки (кроме дублей и очистки полей) и попробуйте загрузить файл еще раз.'"
        />
        <message
            v-if="activeStepId === 2 && isButtonsShow !== true"
            :text="'Файл успешно загружен'"
            :styleClass="{
              color: '#fff',
              background: '#3cb371',
              padding: '5px 0 5px 20px',
              margin: '5px 0 5px 0',
              'border-radius': '10px'
            }"
        />
        <div
            v-if="isButtonsShow === false"
            class="view-import__btn-container"
        >
            <button
                @click="onClickCancel"
                class="btn_default"
            >
                {{activeStepId === 1 ? 'Отменить' : 'Вернуться'}}
            </button>
            <button
                v-if="activeStepId === 1 && canUpload"
                @click="onClickUpload"
                class="btn_default"
            >
                Загрузить
            </button>
        </div>
        <table-with-tabs
            v-if="activeStepId !== 2 || isButtonsShow === true"
            :tableTabs="importReportsTableTabs"
        />
    </div>
</template>

<script>
import StatusBar from '../../components/Base/StatusBar';
import TableWithTabs from '../../components/Tables/TableWithTabs';
import Message from "../../components/Base/Message";
export default {
    name: 'ViewImportRun',
    components: {
        StatusBar,
        TableWithTabs,
        Message
    },
    /**
     * входные данные компонента
     * @property {number} activeStepId - идентификатор активного шага
     * @property {number} statusBarPercent - процент для статус-бара
     * @property {boolean} isButtonsShow - условие показа панели с кнопками
     * @property {object} importReportsTableTabs - таблица отчета об ошибках разбитая по табам
     */
    props: {
        activeStepId: {
            type: Number,
            default: 1
        },
        statusBarPercent: {
            type: Number,
            default: 0
        },
        isButtonsShow: {
            type: Boolean,
            default: false
        },
        canUpload: {
            type: Boolean,
            default: false
        },
        importReportsTableTabs: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        /**
         * событие клика по кнопке отмена
         */
        onClickCancel() {
            this.$emit('onClickCancel');
        },
        /**
         * событие клика по кнопке загрузить
         */
        onClickUpload() {
            this.$emit('onClickUpload');
        }
    }
}
</script>

<style lang="scss" scoped>
    .view-import__table {
        margin-top: 20px
    }
</style>